import { Briefcase } from 'lucide-react'

import { EntityManageSection } from '@/components/ui/entity-manage-section'

export type JobOpeningExperienceRead = {
  id: string
  description: string
}

export type JobOpeningExperiencesReadSectionProps = {
  experiences: JobOpeningExperienceRead[]
  onEdit?: () => void
  editAriaLabel?: string
  editTitle?: string
  emptyMessage?: string
}

export function JobOpeningExperiencesReadSection({
  experiences,
  onEdit,
  editAriaLabel = 'Edit experience requirements',
  editTitle = 'Edit experience requirements',
  emptyMessage = 'No experience requirements listed.',
}: JobOpeningExperiencesReadSectionProps) {
  if (experiences.length === 0) {
    if (onEdit) {
      return (
        <EntityManageSection
          title="Experience requirements"
          leadingIcon={Briefcase}
          subtitle="Background the role expects"
          onEdit={onEdit}
          editAriaLabel={editAriaLabel}
          editTitle={editTitle}
        >
          <p className="text-sm text-muted-foreground">{emptyMessage}</p>
        </EntityManageSection>
      )
    }
    return null
  }

  return (
    <EntityManageSection
      title="Experience requirements"
      leadingIcon={Briefcase}
      subtitle="Background the role expects"
      onEdit={onEdit}
      editAriaLabel={editAriaLabel}
      editTitle={editTitle}
    >
      <ul className="list-disc space-y-2 pl-5 text-sm text-muted-foreground">
        {experiences.map((experience) => (
          <li key={experience.id} className="whitespace-pre-wrap">
            {experience.description}
          </li>
        ))}
      </ul>
    </EntityManageSection>
  )
}
